<template>
  <div class="-ml-6 w-[calc(100%_+_3rem)] flex justify-center py-4  gap-4">
    <div v-if="this.visibleScroll" @click="scrollLeft" class="w-10 border-white h-10 shrink-0 cursor-pointer border-2 font-bold flex items-center justify-center rounded-full bg-white">
      <i class="fas fa-chevron-left"></i>
    </div>
    <PerfectScrollbar ref="categoriesContainer" class="max-w-[calc(100%_-_140px)] relative overflow-hidden pb-3">
      <div class="flex gap-4">
        <div v-for="category in categories" :key="category.id"
            @click="$emit('select', category.id)"
            class="cursor-pointer shrink-0 flex flex-col items-center justify-center gap-1">
            <img :src="category.icon" :alt="category.name"
              :class="{
                'border-[var(--primary-color)]': selectedCategory == category.id,
                'border-white': selectedCategory != category.id
              }"
              class="w-10 border-2 h-10 rounded-full" />
          <div class="text-sm">{{ category.name }}</div>
        </div>
      </div>
    </PerfectScrollbar>
    <div v-if="this.visibleScroll" @click="scrollRight" class="w-10 border-white h-10 shrink-0 cursor-pointer border-2 font-bold flex items-center justify-center rounded-full bg-white">
      <i class="fas fa-chevron-right"></i>
    </div>
  </div>
</template>

<script>
  import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

  export default {
    name: 'CategoriesSelector',
    props: {
      categories: Array,
      selectedCategory: String | Number,
    },
    components: {
      PerfectScrollbar
    },
    data() {
      return {
        visibleScroll: false
      }
    },
    watch: {
      categories() {
        this.$nextTick(() => {
          this.checkScroll();
        })
      }
    },
    mounted() {
      window.addEventListener('resize', this.checkScroll)
      this.checkScroll();
      if (!this.selectedCategory) {
        this.$emit('select', this.categories[0].id)
      }
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.checkScroll)
    },
    methods: {
      checkScroll() {
        console.log(this.$refs.categoriesContainer?.$el, window.innerWidth - 200)
        this.visibleScroll = this.$refs.categoriesContainer?.$el?.clientWidth > window.innerWidth - 200;
      },
      scrollLeft() {
        this.$refs.categoriesContainer.$el.scrollBy({
          left: -50,
        })
      },
      scrollRight() {
        this.$refs.categoriesContainer.$el.scrollBy({
          left: 50
        })
      },
    }
  }
</script>